module.exports = __webpack_public_path__ + "img/BA.d580a569.png";